import { FC } from 'react';
import { ICollaboration } from '@components/projects/level01/level01.state';
import styles from './collaborations.module.scss';
import parse from 'html-react-parser';
import Level01Animation from '@components/projects/level01/animations';
import animations from '../../animations/animations.module.scss';

interface ICollaborationSectionProps {
    section: ICollaboration;
}

const CollaborationsSection: FC<ICollaborationSectionProps> = ({ section }) => {
    return (
      <Level01Animation render={(ref) => (
        <section ref={ref} className={`${styles.section} ${animations.scroll__animation}`}>
            <div className={styles.section__head}>
                <h2 className={styles.section__title}>{section.title}</h2>
            </div>
            <div className={styles.section__content}>
                {section.content.map((item, idx) => (
                    <p key={item} className={styles.section__content_item}>{parse(item)}</p>
                ))}
            </div>
        </section>
      )}/>
    )
}

export default CollaborationsSection;
